import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import firebase from 'firebase';

const styles = theme => ({
  card: {
    minWidth: 275,
  },
  div: {
    marginBottom: '8px',
  }
});


class NewEntryWidget extends Component {
  state = {
    text: '',
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  startNewEntry = () => {
    var ref = firebase.firestore().collection('users').doc(firebase.auth().currentUser.uid)
      .collection('entries').doc();

    ref.set({
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      text: '',
      type: 'general',
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.div}>
        <Button raised color="primary" onClick={this.startNewEntry}>Start a new entry</Button>
      </div>
    );
  }
}


NewEntryWidget.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NewEntryWidget);



// WEBPACK FOOTER //
// ./src/NewEntryWidget.js